export function matchHeight() {
  const getDivs = document.getElementsByClassName('js-match-height');
  const arrayLength = getDivs.length;
  const heights = [];

  for (let i = 0; i < arrayLength; i += 1) {
    heights.push(getDivs[i].offsetHeight);
  }

  function getHighest() {
    return Math.max(...heights);
  }

  const tallest = getHighest();

  for (let i = 0; i < getDivs.length; i += 1) {
    getDivs[i].style.height = `${tallest}px`;
  }
}
